module.exports = __webpack_public_path__ + "img/instructor.4191057d.png";